import styled from 'styled-components'

import Creator1 from '~/shared/assets/images/creater-1.png'
import Creator2 from '~/shared/assets/images/creater-2.png'
import Creator3 from '~/shared/assets/images/creater-3.png'
import Creator4 from '~/shared/assets/images/creater-4.png'
import Creator5 from '~/shared/assets/images/creater-5.png'
import Creator6 from '~/shared/assets/images/creater-6.png'
import Creator7 from '~/shared/assets/images/creater-7.png'
import Creator8 from '~/shared/assets/images/creater-8.png'
import Creator9 from '~/shared/assets/images/creater-9.png'
import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

function FamousCreator() {
  return (
    <Wrapper>
      <Tag $size="md" $variant="gray">
        유명 창작자
      </Tag>
      <Desc>
        SNS, 커뮤니티에서 유명세를 얻고 있는 아마추어 & 프로 창작자 다수 참여
        (전회 기준)
      </Desc>
      <Grid>
        <Creator>
          <Image src={Creator1} alt="AppleCaramel" />
          <CreatorName>AppleCaramel</CreatorName>
          <Job>일러스트레이터</Job>
        </Creator>
        <Creator>
          <Image src={Creator2} alt="순수한불순물" />
          <CreatorName>순수한불순물</CreatorName>
          <Job>일러스트레이터</Job>
        </Creator>
        <Creator>
          <Image src={Creator3} alt="50mang쏘망" />
          <CreatorName>50mang쏘망</CreatorName>
          <Job>작곡가</Job>
        </Creator>
        <Creator>
          <Image src={Creator4} alt="상록수" />
          <CreatorName>상록수</CreatorName>
          <Job>작곡가</Job>
        </Creator>
        <Creator>
          <Image src={Creator5} alt="CHRIS" />
          <CreatorName>CHRIS</CreatorName>
          <Job>일러스트레이터</Job>
        </Creator>
        <Creator>
          <Image src={Creator6} alt="HxxG" />
          <CreatorName>HxxG</CreatorName>
          <Job>일러스트레이터</Job>
        </Creator>
        <Creator>
          <Image src={Creator7} alt="Leviathan" />
          <CreatorName>Leviathan</CreatorName>
          <Job>일러스트레이터</Job>
        </Creator>
        <Creator>
          <Image src={Creator8} alt="지혜" />
          <CreatorName>지혜</CreatorName>
          <Job>작곡가</Job>
        </Creator>
        <Creator>
          <Image src={Creator9} alt="JUNA" />
          <CreatorName>JUNA</CreatorName>
          <Job>작곡가</Job>
        </Creator>
      </Grid>
    </Wrapper>
  )
}

export default FamousCreator

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  height: auto;
  margin: 0 auto;
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const Desc = styled.div`
  font-size: 18px;
`

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 34px;
  justify-content: flex-start;

  @media ${theme.device.medium} {
    gap: 16px;
    justify-content: center;
  }
`

const Creator = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;

  width: 176px;

  @media ${theme.device.medium} {
    width: 45%; /* 2개씩 배치하기 위해 45%로 설정 */
  }
`

const Image = styled.img`
  width: 176px;
  height: 138px;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
  }
`

const CreatorName = styled.div`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 18px;
  font-weight: 500;
`

const Job = styled.div`
  font-size: 15px;
  color: #8bd2d7;
  text-align: center;
`
